// extracted by mini-css-extract-plugin
export default {"reset":"jqHEyK2CnlaIN_sEAo9u"};